<template>
  <div class="genebank">
    <Aheader :realIndex="1"></Aheader>
    <div class="banner">
      <div>
        <p>
          An open-access repository contains taxonomic information and genome
          sequences for more than 200 species of freshwater algae.
        </p>
      </div>
    </div>
    <div class="content">
      <div class="data-box">
        <div class="item" v-for="item in data" :key="item.index">
          <p class="title">{{ item.gsName }}</p>
          <div v-for="ele in item.children" :key="ele.index">
            <p
              :class="{ canJump: ele.isOpen === 'Yes' }"
              @click="jump(ele.isOpen, ele.speciesId)"
            >
              <span>
                <span style="font-style: italic;">{{ ele.italicName }}</span
                ><span>{{ ele.notItalicName }}</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-backtop
      target=".genebank"
      :visibility-height="100"
      :right="150"
      :bottom="150"
    >
      <i class="el-icon-caret-top"></i>
    </el-backtop>
    <Afooter></Afooter>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import http from '../utils/http'
import Aheader from '../components/aheader.vue'
import Afooter from '../components/afooter.vue'
export default {
  name: 'GeneBank',
  components: {
    Aheader,
    Afooter
  },
  created () {
    this.$store.commit('toTop')
    http.get('/genusLevel', {}, res => {
      if (res.code === 200) {
        this.data = res.data
        this.data.forEach(item => {
          if (item.children.length !== 0) {
            item.children.forEach(ele => {
              let obj = this.$utils.getItalic(ele.speciesName)
              ele.italicName = obj.italicName
              ele.notItalicName = obj.notItalicName
            })
          }
        })
      } else {
        Message.error(`${res.msg}`)
      }
    })
  },
  data () {
    return {
      data: []
    }
  },
  methods: {
    // getItalic (data) {
    //   data.forEach(item => {
    //     if (item.children.length !== 0) {
    //       item.children.forEach(ele => {
    //         let index = ele.speciesName.indexOf('sp.')
    //         if (index !== -1) {
    //           ele.italicName = ele.speciesName.substring(0, index + 3)
    //           ele.notItalicName = ele.speciesName.substring(index + 3)
    //         } else {
    //           let list = ele.speciesName.split(' ')
    //           let list1 = []
    //           list1 = list.splice(0, 2)
    //           ele.italicName = list1.join(' ')
    //           if (list.length !== 0) {
    //             ele.italicName = ele.italicName + ' '
    //             ele.notItalicName = list.join(' ')
    //           }
    //         }
    //       })
    //     }
    //   })
    //   return data
    // },
    jump (active, id) {
      if (active === 'Yes') {
        this.$router.push(`/home/detail?id=${id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.genebank {
  height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  min-width: vw(1200);
  .el-icon-caret-top {
    color: $theme_color;
  }
}
.banner {
  margin-top: vw(81);
  min-width: vw(1200);
  height: vw(356);
  background-image: url('../assets/img/bank-banner.png');
  background-size: 100% 100%;
  padding-top: vw(130);
  box-sizing: border-box;
  div {
    width: vw(1200);
    margin: 0 auto;
    p {
      width: vw(832);
      font-size: vw(24);
      color: #333;
    }
  }
}
.content {
  width: vw(1200);
  margin: vw(66) auto;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;

  .data-box {
    box-shadow: 0px 0px 4px 0px rgba(65, 65, 65, 0.05);
    border: 1px solid rgba(65, 65, 65, 0.05);
    padding: vw(7);
    box-sizing: border-box;
    // display: flex;
    // flex-wrap: wrap;
    // align-items: flex-start;
    column-count: 4;
    column-gap: vw(7);
    .item {
      // width: vw(282);
      border-radius: 6px;
      background: #fafafa;
      box-sizing: border-box;
      break-inside: avoid;
      padding-top: vw(11);
      padding-bottom: vw(5);
      margin-bottom: vw(11);
      .title {
        color: #333333;
        font-size: vw(16);
        margin: 0 0 vw(22) vw(9);
        position: relative;
        font-style: italic;
        font-weight: bold;
        &::after {
          display: block;
          content: '';
          position: absolute;
          bottom: vw(-9);
          left: 0;
          width: vw(260);
          height: 1px;
          background: #dddddd;
        }
      }

      div {
        p {
          color: #666666;
          font-size: vw(14);
          margin: 0 0 vw(15) vw(9);
          > span {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .canJump {
          color: #203ee3;
        }
        &:last-child {
          p {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/geneBank.vue